import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'assets-empty-state',
  templateUrl: 'assets-empty-state.component.html',
  styleUrls: ['assets-empty-state.component.scss'],
})
export class AssetsEmptyStateComponent {}
